export enum Department {
    EmergencyRoom = 0,
    Cardiology = 1,
    InternalMedicine = 2,
    Neurology = 3,
    Orthopaedics = 4,
    OperatingRoom = 5,
    NUM_OF_DEPTS = 6,
}

export const DepartmentToInteger: Record<Department, number> = {
    [Department.EmergencyRoom]: 0,
    [Department.Cardiology]: 1,
    [Department.InternalMedicine]: 2,
    [Department.Neurology]: 3,
    [Department.Orthopaedics]: 4,
    [Department.OperatingRoom]: 5,
    [Department.NUM_OF_DEPTS]: 6,
};

export const IntegerToDepartment: Record<Department, string> = {
    [Department.EmergencyRoom]: "emergencyroom",
    [Department.Cardiology]: "cardiology",
    [Department.InternalMedicine]: "internalmedicine",
    [Department.Neurology]: "neurology",
    [Department.Orthopaedics]: "orthopaedics",
    [Department.OperatingRoom]: "operatingroom",
    [Department.NUM_OF_DEPTS]: "",
};

export const DepartmentToString: Record<Department, string> = {
    [Department.EmergencyRoom]: "Emergency Room",
    [Department.Cardiology]: "Cardiology",
    [Department.InternalMedicine]: "Internal Medicine",
    [Department.Neurology]: "Neurology",
    [Department.Orthopaedics]: "Orthopaedics",
    [Department.OperatingRoom]: "Surgery",
    [Department.NUM_OF_DEPTS]: "UNKNOWN",
};